import Dialog from "../ConfirmableDialog";
import axios from "axios";
import {
  useQuery } from "@tanstack/react-query";
import {
  Box,
  CircularProgress,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useAuth from "../../../hooks/useAuth";
import { apiVariable } from "../../../api/apiVariable";

const fetchEntityData = async (
  token: string | null | undefined,
  endpoint: string,
  id: string | undefined
) => {
  if (!id || !endpoint) return null;
  const { data } = await axios.get(`${apiVariable}/${endpoint}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

interface ReusableModalProps {
  endpoint: string;
  entityId: string;
  open: boolean;
  onClose: () => void;
  title?: string;
  renderData: (data: any) => React.ReactNode;
}

const ReusableInfoModal = ({
  endpoint,
  entityId,
  open,
  onClose,
  title = "Details",
  renderData,
}: ReusableModalProps) => {
  const { token } = useAuth();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [endpoint, entityId],
    queryFn: () => fetchEntityData(token, endpoint, entityId),
    enabled: open && !!entityId,
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Typography color="error">
            Error: {(error as any)?.message}
          </Typography>
        ) : data ? (
          renderData(data)
        ) : (
          <Typography>No data found</Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReusableInfoModal;
